import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserService } from '../services/user.service';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { requireSession } from './auth.guard';

export const gettingStartedGuard: CanActivateFn = (_route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  return requireSession(state.url).pipe(
    switchMap(canActivate => {
      if (!canActivate) return of(false);
      return userService.user$.pipe(
        map(user => {
          if (user && !user.completedTutorial) void router.navigate(['getting-started']);
          return !!user?.completedTutorial;
        }),
      );
    }),
  );
};
